import type { TransferBatch as CompleteTransferBatch } from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';

export const TRANSFER_JOB_MAX_HISTORY = 50;
export const DEFAULT_TRANSFER_JOB_STATE: TransferBatchReactiveMapState = {
  batches: [],
  updatedAt: new Date().toString(),
};

type TransferBatch = Omit<CompleteTransferBatch, 'assetItemCounts'>;

export type TransferBatchReactiveMapState = {
  batches: TransferBatch[];
  updatedAt?: string;
};

export const transferBatchesState = new ReactiveMap<
  string,
  TransferBatchReactiveMapState,
  'transferBatches'
>(null, [['default', DEFAULT_TRANSFER_JOB_STATE]]);
